import {email_html} from "../../../config/tips";
import Code from "../../../components/input/code";
import {useManagerContext} from "../../../sections/emails/ManagerContext";
import {setHtml} from "../documents/editor/EditorContext";

export default function HtmlPanel({errors}) {
    const {email} = useManagerContext();

    return <Code required
        size="md"
        name="html"
        isReady={true}
        tools={false}
        hasErrors={!!errors}
        value={email?.content?.html}
        placeholder={errors ? errors : email_html}
        containerClass="editor-code"
        blurFunction={(e) => setHtml(e)}
    />
}
